import {
  GridView,
  Campaign,
  LibraryBooks,
  CollectionsBookmark,
  StickyNote2,
  Assignment,
  Description,
  Groups,
  LocationCity,
  PeopleAlt,
  NoteAdd,
  ManageAccounts,
  PersonAdd,
  Biotech,
  History,
  SatelliteAlt,
  DeviceHub,
  FlightTakeoff,
  BarChart,
  Terminal,
  AutoAwesome,
  Public,
  Monitor,
  // legacy / fallback
  Home,
  MenuBook,
  Bookmark,
  Science,
  RocketLaunch,
  Rocket,
  Dashboard,
  Cloud,
  Group,
  AccountTree,
  Inventory2,
  Notes,
  School,
  AdminPanelSettings,
  GppGood,
  Add,
  FormatListBulleted
} from '@mui/icons-material'

const SZ = { fontSize: 20 }

export default function renderIcon (string) {
  switch (string) {
    // ── primary icon keys (set in initialState) ──────────────────────────────
    case 'GridView':        return <GridView sx={SZ} />
    case 'Campaign':        return <Campaign sx={SZ} />
    case 'LibraryBooks':    return <LibraryBooks sx={SZ} />
    case 'CollectionsBookmark': return <CollectionsBookmark sx={SZ} />
    case 'StickyNote2':     return <StickyNote2 sx={SZ} />
    case 'Assignment':      return <Assignment sx={SZ} />
    case 'Description':     return <Description sx={SZ} />
    case 'Groups':          return <Groups sx={SZ} />
    case 'LocationCity':    return <LocationCity sx={SZ} />
    case 'PeopleAlt':       return <PeopleAlt sx={SZ} />
    case 'NoteAdd':         return <NoteAdd sx={SZ} />
    case 'ManageAccounts':  return <ManageAccounts sx={SZ} />
    case 'PersonAdd':       return <PersonAdd sx={SZ} />
    case 'Biotech':         return <Biotech sx={SZ} />
    case 'History':         return <History sx={SZ} />
    case 'SatelliteAlt':    return <SatelliteAlt sx={SZ} />
    case 'DeviceHub':       return <DeviceHub sx={SZ} />
    case 'FlightTakeoff':   return <FlightTakeoff sx={SZ} />
    case 'BarChart':        return <BarChart sx={SZ} />
    case 'Terminal':        return <Terminal sx={SZ} />
    case 'AutoAwesome':     return <AutoAwesome sx={SZ} />
    case 'Public':          return <Public sx={SZ} />
    case 'Monitor':         return <Monitor sx={SZ} />

    // ── legacy keys (kept for any external callers) ───────────────────────────
    case 'Home':            return <Home sx={SZ} />
    case 'Dashboard':       return <Dashboard sx={SZ} />
    case 'Book':
    case 'Lessons':         return <MenuBook sx={SZ} />
    case 'Bookmark':        return <Bookmark sx={SZ} />
    case 'Notes':           return <Notes sx={SZ} />
    case 'Test':
    case 'Exolab':          return <Science sx={SZ} />
    case 'Launch':
    case 'Cansat':          return <RocketLaunch sx={SZ} />
    case 'Deploy':
    case 'Flight':          return <Rocket sx={SZ} />
    case 'CloudComputer':
    case 'Sketch':          return <Cloud sx={SZ} />
    case 'Group':
    case 'Users':           return <Group sx={SZ} />
    case 'UserExpert':      return <School sx={SZ} />
    case 'UserManager':     return <AdminPanelSettings sx={SZ} />
    case 'UserPolice':      return <GppGood sx={SZ} />
    case 'Organization':    return <AccountTree sx={SZ} />
    case 'Products':
    case 'Cubes':           return <Inventory2 sx={SZ} />
    case 'Create':          return <Add sx={SZ} />

    default:                return <FormatListBulleted sx={SZ} />
  }
}
